// extracted by mini-css-extract-plugin
export default {"title":"terms_title__S+Lb+","desc":"terms_desc__WiNCg"};